import {ReactEChartsProps} from "../../../../components/charts/ReactECharts";
import {ChartResults} from "../../../../actions/queryBuilderApi";

export const BaseStackedBarChartOption: ReactEChartsProps["option"] = {
    tooltip: {
        trigger: 'item',
        axisPointer: {
            type: 'shadow'
        }
    },
    legend: {
        orient: 'horizontal',
        type: 'scroll',
        bottom: 0,
        height: '180px'
    },
    grid: {
        containLabel: true,
        left: 0,
        right: 0
    },
    xAxis: {
        type: 'category',
    },
    yAxis: {
        type: 'value',
    }
};

export const stackedBarChartOption = (chartData: ChartResults): ReactEChartsProps["option"] => {
    const option = {
        ...BaseStackedBarChartOption,
        xAxis: {
            ...(BaseStackedBarChartOption.xAxis),
            data: chartData.labels
        } as ReactEChartsProps['option']['xAxis'],
        series: chartData.values.map(value => {
            return {
                type: 'bar',
                stack: 'total',
                name: chartData.values.length > 1 ? value.name : undefined,
                data: value.data
            }
        })
    }

    return option as ReactEChartsProps["option"]
}

